module.exports = __webpack_public_path__ + "img/921_page_rebuild3.84164cd6.png";